export const ANBIETER_LOGO_FALLBACK = 'assets/images/bildungstraeger.svg';
